import { generateSeed } from '@/shared/constants';
import type { RenderStateCreator, SeedSlice } from './types';

export const createSeedSlice: RenderStateCreator<SeedSlice> = (set) => ({
  setSeed: (seed) =>
    set((state) => ({
      formData: { ...state.formData, seed },
    })),

  generateRandomSeed: () =>
    set((state) => ({
      formData: { ...state.formData, seed: generateSeed() },
    })),

  generateNextSeed: () =>
    set((state) => {
      // Refine keeps the seed (refinement = deterministic iteration);
      // Explore always re-rolls (exploration = fresh variation).
      if (state.formData.mode === 'refine') {
        return {};
      }
      return {
        formData: { ...state.formData, seed: generateSeed() },
      };
    }),
});
